import React from 'react'
import pic001 from "../references/selection/001.jpg"
import pic002 from "../references/selection/002.jpg"
import pic003 from "../references/selection/003.jpg"
import pic004 from "../references/selection/004.jpg"
import pic005 from "../references/selection/005.jpg"
import pic006 from "../references/selection/006.jpg"
import pic007 from "../references/selection/007.jpg"
import pic008 from "../references/selection/008.jpg"
import pic009 from "../references/selection/009.jpg"
import pic010 from "../references/selection/010.jpg"


export default function ReferencesPage() {
  return (
    <div className='reference-container'>

      <div className='reference-text'>

      <h1>Referenciák:</h1>
  
      <img src={[pic001]} alt="pic001.jpg" />
      <img src={[pic002]} alt="pic002.jpg" />
      <img src={[pic003]} alt="pic003.jpg" />
      <img src={[pic004]} alt="pic004.jpg" />
      <img src={[pic005]} alt="pic005.jpg" />
      <img src={[pic006]} alt="pic006.jpg" />
      <img src={[pic007]} alt="pic007.jpg" />
      <img src={[pic008]} alt="pic008.jpg" />
      <img src={[pic009]} alt="pic009.jpg" />
      <img src={[pic010]} alt="pic010.jpg" />
      </div>
    </div>
  )
}
